var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"md":"3"}},[_c('Fieldset',{attrs:{"id":"salesChannel","title":"Sales Channel"}},[_c('SaleChannels')],1)],1),_c('b-col',{attrs:{"md":"9"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }